function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PlaylistToggle } from 'app/components/tv/customControls/PlaylistToggle';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
import VideoShareButton from 'app/components/tv/customControls/VideoShareButton';
import { MuteToggle } from 'app/components/tv/customControls/MuteToggle';
import { FlexContainer } from 'app/styles/content';
import { FullscreenButton } from 'app/components/tv/customControls/FullscreenButton';
const Wrapper = styled.div.withConfig({
  componentId: "sc-ck2yur-0"
})(["position:fixed;left:0;bottom:0;z-index:9999;display:flex;padding-bottom:", ";padding-left:calc(", " + env(safe-area-inset-left));padding-right:", ";font-size:", ";align-items:flex-end;justify-content:space-between;width:", ";"], SIZES['16'], SIZES['32'], props => props.fullWidth ? "calc(".concat(SIZES['32'], " + env(safe-area-inset-right))") : '0', SIZES['24'], props => props.fullWidth ? '100%' : 'auto');
export const PlayerOptions = _ref => {
  let {
    show,
    onPlaylistToggleClick,
    video,
    isMobile,
    ...props
  } = _ref;
  if (!show) {
    return null;
  }
  const OptionButtons = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlaylistToggle, {
    onClick: onPlaylistToggleClick
  }), /*#__PURE__*/React.createElement(VideoShareButton, {
    video: video
  }), /*#__PURE__*/React.createElement(MuteToggle, _extends({
    labeled: true
  }, props)));
  return isMobile ? /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "PlayerOptions",
    "data-sentry-source-file": "PlayerOptions.tsx"
  }, OptionButtons) : /*#__PURE__*/React.createElement(Wrapper, {
    fullWidth: true,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "PlayerOptions",
    "data-sentry-source-file": "PlayerOptions.tsx"
  }, /*#__PURE__*/React.createElement(FlexContainer, {
    "data-sentry-element": "FlexContainer",
    "data-sentry-source-file": "PlayerOptions.tsx"
  }, OptionButtons), /*#__PURE__*/React.createElement(FullscreenButton, {
    "data-sentry-element": "FullscreenButton",
    "data-sentry-source-file": "PlayerOptions.tsx"
  }));
};